import { Box, Typography } from '@material-ui/core'

import { HSLocation, LocaleOption } from 'routes/highschools/types'

import { PremiumWrapper } from '../PremiumPreview/PremiumWrapper'
import FilterCity from './FilterCity'
import FilterGeomarket from './FilterGeomarket'
import FilterLocale from './FilterLocale'
import FilterState from './FilterState'
import FilterZip from './FilterZip'

type FilterLocationsProps = {
  selectedLocations?: HSLocation[]
  onChangeLocation: (locations: HSLocation[]) => void
  selectedCities: string[]
  onChangeCities: (cities: string[]) => void
  selectedZipCodes: string[]
  onChangeZipCodes: (zipCodes: string[]) => void
  locale: LocaleOption[]
  selectedGeomarkets: string[]
  onChangeGeomarkets: (geomarkets: string[]) => void
  setLocale: (locale: LocaleOption[]) => void
  enabled: boolean
}

const FilterLocations = ({
  selectedLocations,
  onChangeLocation,
  selectedCities,
  onChangeCities,
  selectedZipCodes,
  onChangeZipCodes,
  selectedGeomarkets,
  onChangeGeomarkets,
  locale,
  setLocale,
  enabled,
}: FilterLocationsProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={24}
    >
      <Typography
        component="div"
        variant="h6"
      >
        Location
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={16}
      >
        <FilterState
          selectedLocations={selectedLocations}
          onChangeLocation={onChangeLocation}
        />
        <FilterCity
          selectedCities={selectedCities}
          onChangeCities={onChangeCities}
        />
        <FilterZip
          selectedZipCodes={selectedZipCodes}
          onChangeZipCodes={onChangeZipCodes}
        />
        <PremiumWrapper
          enabled={enabled}
          trackingIdPlacement="locations-filter"
        >
          <FilterGeomarket
            selectedGeomarkets={selectedGeomarkets}
            onChangeGeomarkets={onChangeGeomarkets}
            enabled={enabled}
          />
          <FilterLocale
            locale={locale}
            setLocale={setLocale}
            enabled={enabled}
          />
        </PremiumWrapper>
      </Box>
    </Box>
  )
}

export default FilterLocations
